import * as React from 'react';
import { Select, message } from 'antd';
import StorageService from 'src/services/StorageService';
import I18N, { SUPPORT_LOCALES } from 'src/services/I18NService';

interface LanguageSelectProps {
  // setIsDomestic: (isDomestic: boolean) => void;
}

class LanguageSelect extends React.Component<LanguageSelectProps> {
  constructor(props: LanguageSelectProps) {
    super(props);

    // const defaultValue: string = StorageService.getItem('language') || I18N.defaultLanguage;
    // this.props.setIsDomestic(defaultValue === I18N.defaultLanguage);
  }

  async handleChange(value: string): Promise<void> {
    try {
      await I18N.reset(value);
      StorageService.setItem('language', value);
      window.location.reload();
    } catch (error) {
      message.error(JSON.stringify(error));
    }
  }

  getLanguageOption(): JSX.Element[] {
    const options: JSX.Element[] = [];
    for (const option of SUPPORT_LOCALES) {
      options.push(
        <Select.Option key={option.value} value={option.value}>
          {option.name}
        </Select.Option>
      );
    }
    return options;
  }

  render() {
    const defaultValue: string = StorageService.getItem('language') || 'zh-hans';
    return (
      <Select defaultValue={defaultValue} style={{ width: 120 }} onChange={this.handleChange}>
        {this.getLanguageOption()}
      </Select>
    );
  }
}

export default LanguageSelect;



// WEBPACK FOOTER //
// ./src/components/common/LanguageSelect.tsx